module.exports = __webpack_public_path__ + "static/img/daxue.4d180318.png";